/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DocumentoVersioneDettaglioDTO } from './documento-versione-dettaglio-dto';
import { DocumentoVersioneSintesiDTO } from './documento-versione-sintesi-dto';


export interface DocumentoAdminDTO { 
    id?: string;
    comune_id?: string;
    ordine?: number;
    stato?: DocumentoAdminDTOStatoEnum;
    ritirato_at?: string;
    version?: number;
    titolo?: string;
    versione_corrente?: number;
    bozza?: DocumentoVersioneDettaglioDTO;
    versioni?: Array<DocumentoVersioneSintesiDTO>;
}
export enum DocumentoAdminDTOStatoEnum {
    ATTIVO = 'ATTIVO',
    RITIRATO = 'RITIRATO'
};



